import { IAgeGroupBucketStatus } from './age-group-bucket-settings.types';
import { messages } from './age-group-bucket-settings.messages';

// A row's own status, not the pool's. Order matters: a row with no bucket scores nothing,
// so that reads before how the bucket it doesn't have was arrived at.
export const statusFor = (ageGroup: IAgeGroupBucketSetting): IAgeGroupBucketStatus | null => {
  if (!ageGroup.bucket) {
    return ageGroup.isBucketManual
      ? { label: messages.clearedBucket, color: 'default' }
      : { label: messages.matchedNone, color: 'secondary' };
  }

  if (ageGroup.isBucketManual) return { label: messages.manual, color: 'default' };

  // The stored bucket is what scores; a differing suggestion means the seed weights moved
  // under it, and only an admin's pick will move the row onto the newer match.
  if (ageGroup.suggestedBucket && ageGroup.suggestedBucket !== ageGroup.bucket) {
    return { label: messages.rematch, color: 'secondary', values: { bucket: ageGroup.suggestedBucket } };
  }

  if (ageGroup.matchType === 'NEAREST') return { label: messages.matchedNearest, color: 'primary' };

  return null;
};

// A pinned bucket whose seed weights have since been retired: still the stored answer, but
// no longer offered, so the Select has to render it or the row reads as blank.
export const retiredBucketFor = (ageGroup: IAgeGroupBucketSetting, options: string[]): string | null => (
  ageGroup.bucket && !options.includes(ageGroup.bucket) ? ageGroup.bucket : null
);
